import React, { ReactNode } from 'react'

import * as S from './TemplateContainer.styles'

export interface TemplateContainerProps {
  children: ReactNode
  title: string
  totalCount: number
}

function TemplateContainer({ children, title, totalCount }: TemplateContainerProps): JSX.Element {
  return (
    <S.Container>
      <S.Title>
        {title} &bull; {totalCount}
      </S.Title>
      {children}
    </S.Container>
  )
}

export default TemplateContainer
